import * as React from 'react'
import { graphql } from 'gatsby'
import LeasingDetailsPage from '../../views/leasingDetailsView'

const StandardPersonalFinance = (props) => (
  <LeasingDetailsPage
    {...props}
    calculatorType="personal-finance-standard"
    productFeatureType="personal-finance-standard"
  />
)

export default StandardPersonalFinance

export const query = graphql`
  query StandardPFQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
      sections: pageSection {
        ...leasingDetailFeaturesFragment
        ...leasingDetailSectionFragment
      }
    }
  }
`
